export const calor = require('./calor.png');
export const estatDeLaMar = require('./estat-de-la-mar.png');
export const fred = require('./fred.png');
export const logoPNG = require('./logo.png');
export const logoSVG = require('./logo.svg');
export const meteocat = require('./meteocat.svg');
export const neu = require('./neu.png');
export const paraigues = require('./paraigues.png');
export const pluja = require('./pluja.png');
export const acumulacio = require('./acumulacio.png');
export const intensitat3h = require('./intensitat3h.png');
export const intensitat = require('./intensitat30min.png');
export const vent = require('./vent.png');
export const logo_generalitat = require('./logo-generalitat.png');
export const dts = require('./dts.png');
export const chevron = require('./chevron.svg');
export const check = require('./check.svg');
export const tempsViolent = require('./temps_violent.png');
export const calorNocturna = require('./calor_nocturna.png');

// Meteors
export const est_cel_1 = require('./1.svg');
export const est_cel_2 = require('./2.svg');
export const est_cel_3 = require('./3.svg');
export const est_cel_4 = require('./4.svg');
export const est_cel_5 = require('./5.svg');
export const est_cel_6 = require('./6.svg');
export const est_cel_7 = require('./7.svg');
export const est_cel_8 = require('./8.svg');
export const est_cel_9 = require('./9.svg');
export const est_cel_10 = require('./10.svg');
export const est_cel_11 = require('./11.svg');
export const est_cel_12 = require('./12.svg');
export const est_cel_13 = require('./13.svg');
export const est_cel_20 = require('./20.svg');
export const est_cel_21 = require('./21.svg');
export const est_cel_22 = require('./22.svg');
export const est_cel_23 = require('./23.svg');
export const est_cel_24 = require('./24.svg');
export const est_cel_25 = require('./25.svg');
export const est_cel_26 = require('./26.svg');
export const est_cel_27 = require('./27.svg');
export const est_cel_28 = require('./28.svg');
export const est_cel_29 = require('./29.svg');
export const est_cel_30 = require('./30.svg');
export const est_cel_31 = require('./31.svg');
export const est_cel_32 = require('./32.svg');
export const est_cel_1n = require('./1n.svg');
export const est_cel_2n = require('./2n.svg');
export const est_cel_3n = require('./3n.svg');
export const est_cel_4n = require('./4n.svg');
export const est_cel_5n = require('./5n.svg');
export const est_cel_6n = require('./6n.svg');
export const est_cel_7n = require('./7n.svg');
export const est_cel_8n = require('./8n.svg');
export const est_cel_9n = require('./9n.svg');
export const est_cel_10n = require('./10n.svg');
export const est_cel_11n = require('./11n.svg');
export const est_cel_12n = require('./12n.svg');
export const est_cel_13n = require('./13n.svg');
export const est_cel_20n = require('./20n.svg');
export const est_cel_21n = require('./21n.svg');
export const est_cel_22n = require('./22n.svg');
export const est_cel_23n = require('./23n.svg');
export const est_cel_24n = require('./24n.svg');
export const est_cel_25n = require('./25n.svg');
export const est_cel_26n = require('./26n.svg');
export const est_cel_27n = require('./27n.svg');
export const est_cel_28n = require('./28n.svg');
export const est_cel_29n = require('./29n.svg');
export const est_cel_30n = require('./30n.svg');
export const est_cel_31n = require('./31n.svg');
export const est_cel_32n = require('./32n.svg');
export const est_mar_50 = require('./50.svg');
export const est_mar_51 = require('./51.svg');
export const est_mar_52 = require('./52.svg');
export const est_mar_53 = require('./53.svg');
export const est_mar_54 = require('./54.svg');
export const est_mar_55 = require('./55.svg');
export const est_mar_56 = require('./56.svg');
export const est_mar_57 = require('./57.svg');
export const est_mar_58 = require('./58.svg');
export const est_mar_59 = require('./59.svg');
export const est_mar_60 = require('./60.svg');
export const vent_01 = require('./N01.svg');
export const vent_05 = require('./N05.svg');
export const vent_10 = require('./N10.svg');
export const vent_15 = require('./N15.svg');
export const vent_20 = require('./N20.svg');
export const vent_25 = require('./N25.svg');
export const vent_30 = require('./N30.svg');
export const vent_35 = require('./N35.svg');
export const vent_40 = require('./N40.svg');
export const vent_45 = require('./N45.svg');
export const vent_50 = require('./N50.svg');
export const vent_55 = require('./N55.svg');
export const vent_60 = require('./N60.svg');
export const vent_direccio = require('./vent-direccio.svg');
export const vent_direccio_0 = require('./vent-direccio-0.svg');
export const vent_direccio_5 = require('./vent-direccio-5.svg');
export const vent_direccio_10 = require('./vent-direccio-10.svg');
export const vent_direccio_20 = require('./vent-direccio-20.svg');
export const vent_direccio_30 = require('./vent-direccio-30.svg');
export const vent_direccio_40 = require('./vent-direccio-40.svg');
export const vent_var = require('./var.svg');
export const temp_tg_puja = require('./TgPuja.svg');
export const temp_tg_mante = require('./TgMante.svg');
export const temp_tg_baixa = require('./TgBaixa.svg');
export const temp_tn_puja = require('./TnPuja.svg');
export const temp_tn_mante = require('./TnMante.svg');
export const temp_tn_baixa = require('./TnBaixa.svg');
export const temp_tx_puja = require('./TxPuja.svg');
export const temp_tx_mante = require('./TxMante.svg');
export const temp_tx_baixa = require('./TxBaixa.svg');

// Social Media
export const facebook_icon = require('./facebook.svg');
export const twitter_icon = require('./twitter.svg');
export const youtube_icon = require('./youtube.svg');
export const instagram_icon = require('./instagram.svg');
export const linkedin_icon = require('./linkedin.svg');
export const cloudsound_icon = require('./soundcloud.svg');

export const tramaSmp0 = require('./trama-smp-0.png');
export const tramaSmp1 = require('./trama-smp-1.png');
export const tramaSmp2 = require('./trama-smp-2.png');
export const tramaSmp3 = require('./trama-smp-3.png');

export const llegendaSmp0 = require('./llegenda-smp-0.png');
export const llegendaSmp1 = require('./llegenda-smp-1.png');
export const llegendaSmp2 = require('./llegenda-smp-2.png');
export const llegendaSmp3 = require('./llegenda-smp-3.png');



// WEBPACK FOOTER //
// ./src/img/index.js